export default __webpack_public_path__ + "static/media/7.0c0746c6.webp";